import React, { useEffect, useState } from "react";
import { Table, Card } from "react-bootstrap";
import { useParams } from "react-router-dom";
// import { fetchSubscriberHistoryById } from "../../service/SubscriptionHistoryService";
import Main from "../components/admin/Main";
import PageContainer from "../components/admin/PageContainer";
import { fetchSubscriberHistoryById } from "../service/SubscriptionHistoryService";
import CollapseCard from "../components/admin/CollapseCard";
// import Main from "./Main";
// import PageContainer from "./PageContainer";

const SubscriptionHistory = () => {
  const { id: userId } = useParams();
  const [history, setHistory] = useState([]);

  const loadSubscriptionHistory = async () => {
    try {
      const res = await fetchSubscriberHistoryById(userId);
     
      const sortedData = res.sort(
        (a,b)=>new Date(b.createTimestamp)-new Date(a.createTimestamp)
      )
   
      setHistory(sortedData);
    } catch (error) {
      console.error("Error fetching subscription history", error);
    }
  };

  useEffect(() => {
    loadSubscriptionHistory();
  }, [userId]);


  return (
    <>
      <Main>
        <PageContainer title="Subscription History">
          <CollapseCard title="User Detail's">
            <Card className="">
              <Card.Body>
                <h5>UserName: {history.username}</h5>
                <p>Email: {history.email}</p>
              </Card.Body>
            </Card>
          </CollapseCard>
          <CollapseCard title="Subscription History List">
            <Table className="custom-employee-table" bordered hover responsive>
              <thead>
                <tr>
                  <th>SI.NO</th>
                  <th>Plan</th>
                  <th>Amount</th>
                  <th>Payment Mode</th>
                  <th>Payment Particulars</th>
                  <th>Expiry Date</th>
                  <th>Created At</th>
                </tr>
              </thead>
              <tbody>
                {history.length > 0 ? (
                  history.map((item, index) => (
                    <tr key={item.subscriptionHistoryId || index}>
                      <td>{index + 1}</td>
                      <td>{item.plan}</td>
                      <td>{item.amount}</td>
                      <td>{item.paymentMode || "N/A"}</td>
                      <td>{item.paymentParticulars || "N/A"}</td>
                      <td>{item.expiryDate}</td>
                      <td>{item.createTimestamp.split(" ")[0]}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center">No data found</td>
                  </tr>
                )}
              </tbody>
            </Table>
          </CollapseCard>
        </PageContainer>
      </Main>
    </>
  );
};

export default SubscriptionHistory;
